const warnableSelector = '[data-warnable]';
const hideGeneralTermsSelector = '[data-hide-general-terms]';

function warnableElements() {
  return $(warnableSelector);
}

function hideGeneralTermsElements() {
  return $(hideGeneralTermsSelector);
}

function zeroedElements(elementsToCheck) {
  return elementsToCheck.filter((i, el) => el.value === '0');
}

function toggleNoReturnsWarning(target, elements) {
  if (elements.length > 0) {
    target.slideDown();
  } else {
    target.slideUp();
  }
}

function toggleGeneralTerms(target, elements) {
  if (hideGeneralTermsElements().length === elements.length) {
    target.slideUp();
  } else {
    target.slideDown();
  }
}

function bindNoReturnsWarningToggle() {
  $(document).on('change', warnableSelector, () => {
    const noReturnsWarning = $(`[${warnableElements().data('warnable')}]`);

    toggleNoReturnsWarning(noReturnsWarning, zeroedElements(warnableElements()));
  });
}

function bindHideGeneralTerms() {
  $(document).on('change', hideGeneralTermsSelector, () => {
    const generalTerms = $(`[${hideGeneralTermsElements().data('hide-general-terms')}]`);

    toggleGeneralTerms(generalTerms, zeroedElements(hideGeneralTermsElements()));
  });
}

function init() {
  bindNoReturnsWarningToggle();
  bindHideGeneralTerms();
}

$(init);

export default { init };
